import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {StockSearch, StockSearchRequest} from './stock-search';

@Injectable()
export class StockSearchService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all stockSearchs which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.stockSearchURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(stockSearch : StockSearch) {
    console.log('Push stockSearch to insert method of service.');
    stockSearch.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(stockSearch));
    return this.http.post(this.config.stockSearchURL+"new", JSON.stringify(stockSearch), {headers: this.headers});
  }

  public update(stockSearch : StockSearch) {
    console.log('Push stockSearch to update method of service.');
    stockSearch.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(stockSearch));
    return this.http.put(this.config.stockSearchURL+"id/"+stockSearch.id, JSON.stringify(stockSearch), {headers: this.headers});
  }

  public qryStockSearch(id : number) {
    return this.http.post(this.config.stockSearchURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete stockSearch '+ id);
    return this.http.post(this.config.stockSearchURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public search(request : StockSearchRequest) {
    request.credentials = this.shared.getTokenAuthData();
    console.log('stock search: ' + JSON.stringify(request));
    return this.http.post(this.config.stockSearchTaskURL,
      JSON.stringify(request), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/stock/stock-search.service.ts